import React from 'react';

const Button = ({
  variant = 'primary',
  children,
  onClick,
  href,
  className = '',
  type = 'button', // garante que botões não submetem formulários por defeito
}) => {
  const base = 'inline-flex items-center justify-center px-4 py-2 font-medium text-sm rounded-md focus:outline-none';
  const primary = 'bg-[#034a36] text-white hover:bg-[#023325]';
  const secondary = 'bg-transparent border border-[#034a36] text-[#034a36] hover:bg-[#f7fdf8]';

  const classes = `${base} ${variant === 'primary' ? primary : secondary} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes} onClick={onClick}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} className={classes} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
